<template>
  <input v-model="localValue" :type="type" class="form-control" :readonly="readonly" :placeholder="placeholder">
</template>

<script>
  export default {
    name: 'o-input-control',
    props: {
      value: {
        default: null
      },
      type: {
        type: String,
        default: 'text'
      },
      readonly: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String
      }
    },

    data: () => ({
      localValue: ''
    }),

    mounted() {
      this.localValue = this.value
    },

    components: {},

    watch: {
      value(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.localValue = newVal
        }
      },
      localValue(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('input', newVal)
        }
      }
    },

    methods: {}
  }
</script>
